module.exports = __webpack_public_path__ + "d2a0cd581d0e17d735adc4f00054c8eb.png";